import React from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Log } from '../../thermometers/views/log';
import { GraphicLog } from '../../thermometers/views/historic-log';
import { Sider, Main } from '../components';

const ROUTES = [
  {
    name: I18n('daily_graph', true),
    key: 'daily-graph',
    path: '/environment/max-and-min-temperature/daily-graph',
    component: GraphicLog,
  },
  {
    name: I18n('data_table', true),
    key: 'table',
    path: '/environment/max-and-min-temperature/table',
    component: Log,
  },
];

export function TemperatureMaxMin() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('max_and_min_temperature', true)}
          key={'max_and_min_temperature'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
